import { render, staticRenderFns } from "./ProgramDetailView.vue?vue&type=template&id=2c391d29&scoped=true&"
import script from "./ProgramDetailView.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailView.vue?vue&type=style&index=0&id=2c391d29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c391d29",
  null
  
)

export default component.exports